import { render, staticRenderFns } from "./MbFileManager.vue?vue&type=template&id=678e1112&"
import script from "./MbFileManager.vue?vue&type=script&lang=js&"
export * from "./MbFileManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports